import React, { useCallback, useEffect, useReducer, useState } from "react";
import ReactDOM from "react-dom";

import VarietiesTable from "./components/read-only/variety-table";

import { cacheOrLoad } from "components/attributes/lib/cache";
import { getAttributesByGroup } from "components/attributes/lib/attribute-data";
import { reducer } from "./reducer";
import { varietyListMap, varietyWithLinkList } from "./lib/helper";

const ReadOnlyVarietyPacks = (props) => {
    const [attributeList, setAttributeList] = useState([]);
    const [varietyData, dispatch] = useReducer(reducer, {});

    useEffect(() => {
        buildData();
    }, []);

    const buildData = async () => {
        const parentGroup = props.attribute.additionalInfo.parentGroupInfo.parentGroupName;

        if (parentGroup) {
            const attrList = await cacheOrLoad(parentGroup, getAttributesByGroup);

            setAttributeList(attrList);
        }

        dispatch({ type: "INIT", value: props.defaultValue });
    };

    const handleClose = useCallback(() => {
        props.handleClose();
    });

    return ReactDOM.createPortal(
        <div className="page-takeover">
            <div className="container">
                <VarietiesTable
                    upc={props.upc}
                    attributeList={attributeList}
                    handleClose={handleClose}
                    varieties={varietyListMap(varietyData)}
                    varietiesWithLinks={varietyWithLinkList(varietyData)}
                    varietyData={varietyData}
                />
            </div>
        </div>,
        document.getElementById("attribute-section")
    );
};

export default ReadOnlyVarietyPacks;
